/** Formats 16 random bytes as an RFC4122 v4 UUID string. */
function formatUuidV4FromBytes(bytes: Uint8Array): string {
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  let hex = '';
  for (const byte of bytes) {
    hex += byte.toString(16).padStart(2, '0');
  }
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/**
 * Generates a cryptographically secure UUID suitable for payment idempotency keys.
 * Matches the exhibitor checkout implementation (`generateSecureIdempotencyKey`).
 */
export function generateSecureIdempotencyKey(): string {
  const cryptoObj = globalThis.crypto;
  if (typeof cryptoObj?.randomUUID === 'function') {
    return cryptoObj.randomUUID();
  }
  if (typeof cryptoObj?.getRandomValues !== 'function') {
    throw new TypeError('Secure random number generator is not available.');
  }
  const bytes = new Uint8Array(16);
  cryptoObj.getRandomValues(bytes);
  return formatUuidV4FromBytes(bytes);
}
